import { styled } from 'styled-components';
import { colors } from '../../../abstracts/colors';
import { createTransition, dontForwardProps } from '../../../util';
import { getBoxShadow } from '../../../util/styling';
import { getBoxShadowColor } from './TextareaHelperText';
const createBoxShadow = ({
  fieldStatus,
  isFocus,
  isHover,
  disabled,
  hasContent
}) => {
  const fieldStatusColors = {
    success: colors.successDeeper,
    warn: colors.warningBright,
    error: colors.errorDeep,
    default: colors.neutralDeeper
  };
  const shadowColor = getBoxShadowColor({
    fieldStatus,
    isFocus,
    isHover,
    disabled,
    hasContent,
    shadowColors: fieldStatusColors
  });
  const size = isFocus ? 0.125 : 0.0625;
  return getBoxShadow(size, shadowColor);
};
export const TextareaContainer = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-58id5b-0"
})(["position:relative;display:flex;flex-direction:column;border-radius:0.5rem;box-sizing:border-box;box-shadow:", ";", " ", " padding-bottom:3px;cursor:text;background-color:", ";"], createBoxShadow, ({
  disabled
}) => disabled && `color: ${colors.disabledText};
     background-color:  ${colors.disabledBackground};
  `, createTransition({
  properties: ['box-shadow']
}), colors.white);